import { Component, Input, Output, EventEmitter } from '@angular/core';


declare var Razorpay: any;
@Component({
  selector: 'app-razorpay-checkout',
  templateUrl: './razorpay-checkout.component.html',
  styleUrls: ['./razorpay-checkout.component.css']
})
export class RazorpayCheckoutComponent {
  // Pass details dynamically into this component from parent pages
  @Input() amountInRupees: number = 0;
  @Input() backendOrderId: string = ''; 
  
  // Emit events back to the parent component when the payment status changes
  @Output() paymentSuccess = new EventEmitter<any>();
  @Output() paymentFailed = new EventEmitter<any>();

  payWithRazorpay() {
    if (!this.backendOrderId) {
      alert('Missing Order ID from server!');
      return;
    }

    const options = {
      key: 'rzp_live_RAGbnSyb9t0e18', 
      amount: this.amountInRupees * 100, // Convert to Paise automatically
      currency: 'INR',
      name: 'Your App Name',
      description: 'Product Purchase',
      order_id: this.backendOrderId,
      handler: (response: any) => {
        // Send payment metadata back up to the parent component
        this.paymentSuccess.emit(response);
      },
      prefill: {
        name: 'Customer Name',
        email: 'customer@example.com'
      },
      theme: {
        color: '#C8A84B'
      },
      modal: {
        ondismiss: () => {
          this.paymentFailed.emit({ message: 'User closed modal' });
        }
      }
    };

    const rzp = new Razorpay(options);
    rzp.open();
  }
}